<script lang="ts" setup>
import { cn } from '@/lib/utils'

defineProps<{
    class?: string
}>()
</script>

<template>
    <div
        :class="
            cn(
                'relative flex w-full items-center overflow-hidden rounded-md font-bold transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-within:ring-[3px] focus-within:outline-hidden',
            )
        "
    >
        <slot />
    </div>
</template>
